import { ContributorType } from "@/src/types";
import React from "react";
import ContentContainer from "../containers/ContentContainer";
import ContributorSocials from "../contributor/socials";
import { Typography } from "@material-tailwind/react";
import Link from "next/link";

export interface ContributorHeaderProps {
  contributor: ContributorType;
}

const ContributorHeader = ({ contributor }: ContributorHeaderProps) => {
  return (
    <div className={"bg-white contributor-header py-2 px-2"}>
      <div className={"flex "}>
        <div className={"container flex mx-auto gap-x-2 flex-col md:flex-row"}>
          <div
            style={{
              backgroundSize: "cover",

              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${contributor?.contributormeta?.image?.node?.mediaItemUrl})`,
            }}
            className={
              "w-[100%] md:w-[400px] pb-[100%] md:pb-[20%] md:h-full md:min-w-[250px]"
            }
          ></div>

          <div className={"flex flex-col p-2 h-[100%]"}>
            <Typography variant="h5">
              <Link href="/contributors">
                <span className="font-light ">Contributors / </span>
              </Link>
              <b>{contributor?.name}</b>
            </Typography>
            <Typography variant="paragraph">
              {contributor?.contributormeta?.bio}
            </Typography>
            <div className={"mt-auto"}>
              <ContributorSocials contributor={contributor} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributorHeader;
